import { AxiosPromise } from 'axios';
import { EndPointService } from '../api-handlers/axios';

function getEnums(params: any): AxiosPromise {
    return EndPointService.get('/enums', { params });
}

function getAgencyInfo(params: any): AxiosPromise {
    return EndPointService.get('/agency_infos', { params });
}
function updateAgencyInfo(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/agency_infos/${id}`, payload);
}

function createAgencyFiles(id: string | number, payload: any): AxiosPromise {
    return EndPointService.post(`/agency_infos/logo-doc`, payload, {
        params: {
            id: id,
        },
    });
}

function fetchDashBoard(): AxiosPromise {
    return EndPointService.get(`/dashboard/general`);
}

export default {
    getEnums,
    fetchDashBoard,
    createAgencyFiles,
    getAgencyInfo,
    updateAgencyInfo,
};
